function initFluxynaraHelp(root) {
  if (!root || root.dataset.helpInitialized === "true") return;
  root.dataset.helpInitialized = "true";

  const cards = Array.from(root.querySelectorAll("[data-idea-card]"));
  const details = Array.from(root.querySelectorAll("[data-layout-detail]"));
  const grid = root.querySelector("[data-idea-list]");
  const search = root.querySelector("[data-library-search]");
  const clear = root.querySelector("[data-library-clear]");
  const searchWrap = search?.closest(".help-library-search");
  const categoryFilter = root.querySelector("[data-category-filter]");
  const typeFilter = root.querySelector("[data-type-filter]");
  const sort = root.querySelector("[data-library-sort]");
  const reset = root.querySelector("[data-library-reset]");
  const count = root.querySelector("[data-ideas-count]");
  const empty = root.querySelector("[data-ideas-empty]");
  const buildsSection = root.querySelector("[data-builds-section]");

  const normalize = (value) => String(value || "").trim().toLocaleLowerCase();
  const categories = [...new Set(cards.map((card) => card.dataset.category).filter(Boolean))];

  function hideLayoutDetails() {
    details.forEach((detail) => {
      detail.hidden = true;
    });
    if (buildsSection) buildsSection.hidden = true;
  }

  function populateCategories() {
    if (!categoryFilter) return;
    categoryFilter.replaceChildren(new Option("All product categories", ""));
    categories.forEach((category) => {
      categoryFilter.append(new Option(category, category));
    });
  }

  function populateTypes(category) {
    if (!typeFilter) return;
    typeFilter.replaceChildren();

    if (!category) {
      typeFilter.append(new Option("Select a category first", ""));
      typeFilter.disabled = true;
      return;
    }

    typeFilter.disabled = false;
    typeFilter.append(new Option("All product types", ""));
    const types = [...new Set(
      cards
        .filter((card) => card.dataset.category === category)
        .map((card) => card.dataset.type)
        .filter(Boolean)
    )];
    types.forEach((type) => {
      typeFilter.append(new Option(type, type));
    });
  }

  function sortCards() {
    if (!grid) return;
    const mode = sort?.value || "popular";
    const sorted = cards.slice().sort((left, right) => {
      if (mode === "name") {
        return String(left.dataset.title || "").localeCompare(String(right.dataset.title || ""));
      }
      if (mode === "pieces") {
        return (parseFloat(left.dataset.pieces) || 0) - (parseFloat(right.dataset.pieces) || 0);
      }
      return Number(left.dataset.order || 0) - Number(right.dataset.order || 0);
    });
    sorted.forEach((card) => grid.append(card));
  }

  function applyFilters() {
    const query = normalize(search?.value);
    const terms = query.split(/\s+/).filter(Boolean);
    const category = categoryFilter?.value || "";
    const type = typeFilter?.value || "";
    let visible = 0;

    sortCards();
    cards.forEach((card) => {
      const searchable = normalize([
        card.dataset.title,
        card.dataset.category,
        card.dataset.type,
        card.dataset.pieces,
        card.textContent
      ].join(" "));
      const matchesSearch = terms.every((term) => searchable.includes(term));
      const matchesCategory = !category || card.dataset.category === category;
      const matchesType = !type || card.dataset.type === type;
      const show = matchesSearch && matchesCategory && matchesType;
      card.hidden = !show;
      if (show) visible += 1;
    });

    searchWrap?.classList.toggle("has-value", Boolean(query));
    if (count) count.textContent = `${visible} ${visible === 1 ? "idea" : "ideas"}`;
    if (empty) empty.hidden = visible !== 0;
    hideLayoutDetails();
  }

  populateCategories();
  populateTypes("");

  categoryFilter?.addEventListener("change", () => {
    populateTypes(categoryFilter.value);
    applyFilters();
  });
  typeFilter?.addEventListener("change", applyFilters);
  sort?.addEventListener("change", applyFilters);
  search?.addEventListener("input", applyFilters);

  clear?.addEventListener("click", () => {
    if (!search) return;
    search.value = "";
    search.focus();
    applyFilters();
  });

  reset?.addEventListener("click", () => {
    if (search) search.value = "";
    if (categoryFilter) categoryFilter.value = "";
    if (sort) sort.value = "popular";
    populateTypes("");
    applyFilters();
  });

  async function copySectionLink(button, target) {
    if (!target?.id) return;
    const url = new URL(window.location.href);
    url.search = "";
    url.hash = target.id;
    const original = button.textContent;

    try {
      await navigator.clipboard.writeText(url.toString());
      button.textContent = "Link copied";
      window.setTimeout(() => {
        button.textContent = original;
      }, 1800);
    } catch (_error) {
      window.location.hash = target.id;
    }
  }

  root.querySelectorAll("[data-copy-layout-link]").forEach((button) => {
    button.addEventListener("click", () => {
      copySectionLink(button, button.closest("[data-layout-detail]"));
    });
  });

  root.querySelectorAll("[data-copy-guide-link]").forEach((button) => {
    button.addEventListener("click", () => {
      copySectionLink(button, button.closest(".help-guide-card"));
    });
  });

  function revealLayoutByKey(layoutKey, shouldScroll) {
    const card = cards.find((item) => item.dataset.layoutKey === layoutKey);
    const detail = details.find((item) => item.dataset.layoutKey === layoutKey);
    if (!card || !detail) return false;

    if (search) search.value = "";
    if (categoryFilter) categoryFilter.value = card.dataset.category || "";
    populateTypes(card.dataset.category || "");
    if (typeFilter) typeFilter.value = card.dataset.type || "";
    applyFilters();

    details.forEach((item) => {
      item.hidden = item !== detail;
    });
    if (buildsSection) buildsSection.hidden = false;

    if (shouldScroll) {
      window.requestAnimationFrame(() => {
        detail.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    }
    return true;
  }

  root.fluxynaraRevealLayout = revealLayoutByKey;

  function openHashTarget() {
    if (!window.location.hash) return;
    let targetId = window.location.hash.slice(1);
    try {
      targetId = decodeURIComponent(targetId);
    } catch (_error) {
      return;
    }

    const target = document.getElementById(targetId);
    if (!target) return;
    if (target.matches("[data-layout-detail]")) {
      revealLayoutByKey(target.dataset.layoutKey, true);
    }
    target.querySelector("[data-help-details]")?.setAttribute("open", "");
  }

  window.addEventListener("hashchange", openHashTarget);
  applyFilters();
  openHashTarget();
}

document.querySelectorAll("[data-help-root]").forEach(initFluxynaraHelp);

if (!window.fluxynaraHelpEditorEventsBound) {
  window.fluxynaraHelpEditorEventsBound = true;

  document.addEventListener("shopify:section:load", (event) => {
    event.target.querySelectorAll?.("[data-help-root]").forEach(initFluxynaraHelp);
  });

  document.addEventListener("shopify:block:select", (event) => {
    const root = event.target.closest?.("[data-help-root]");
    const card = event.target.closest?.("[data-idea-card]");
    if (root && card) {
      root.fluxynaraRevealLayout?.(card.dataset.layoutKey, true);
    }

    const guide = event.target.closest?.(".help-guide-card");
    guide?.querySelector("[data-help-details]")?.setAttribute("open", "");
  });
}
